export default __webpack_public_path__ + "static/media/slider5.8a084f78.jpeg";